import React, {PureComponent, ReactNode} from "react"
import {MutationState} from "react-apollo"
import styled from "styled-components"
import Button from "@irati/ui/src/Button"
import id from "@irati/utils/id"
import {greys} from "@irati/ui/src/global/colors"
import padding from "@irati/ui/src/global/padding"
import {injectIntl, getResolvedMessage, InjectIntl} from "@irati/utils/lang"

const Container = styled.div`
  background: ${greys.white};
  padding: ${padding.tiny};
  width: 210px;
  border-radius: 3px;
  box-shadow: ${({theme}) => theme.shadows.low};
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

interface Props extends InjectIntl {
  id: string,
  apolloState: MutationState,
  children: ReactNode | ReactNode[],
  onConfirm: () => void,
  onCancel: () => void,
  confirmLabel?: string,
  cancelLabel?: string,
  className?: string
}

class Confirm extends PureComponent<Props> {
  static defaultProps = {
    id: "confirm",
    confirmLabel: "recognition.confirm.confirmLabel",
    cancelLabel: "recognition.confirm.cancelLabel",
    onConfirm: () => {},
    onCancel: () => {},
    className: undefined
  }

  handleConfirm = (): void => {
    this.props.onConfirm()
  }

  handleCancel = (): void => {
    this.props.onCancel()
  }

  render() {
    const {
      children,
      className,
      apolloState,
      intl
    } = this.props

    return (
      <Container className={className}>
        {children}
        <ButtonContainer>
          <Button
            id={id("btn-cancel", this.props)}
            onClick={this.handleCancel}>
            {getResolvedMessage(this, "cancelLabel")}
          </Button>
          <Button
            id={id("btn-confirm", this.props)}
            onClick={this.handleConfirm}
            primary
            apolloState={apolloState}>
            {getResolvedMessage(this, "confirmLabel")}
          </Button>
        </ButtonContainer>
        {apolloState.error && <div>{intl.formatMessage({id: apolloState.errorMsg})}</div>}
      </Container>
    )
  }
}

export default injectIntl(Confirm)
